export default __webpack_public_path__ + "static/icon-15-3-82ff7bba0320a480dec21b9237a47e2b.png";